import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    Company,
    StoreIcon,
    GroupIcon,
    OrganizerIcon,
    RoomIcon,
    PollIcon,
    SeminarIcon,
    LiveHelpIcon,
    VisibilityIcon,
    ViewListIcon,
    LiveStreamIcon,
    MailIcon,
    SettingShopping,
    RegisterLiveStream,
    ProductPayment,
    SettingCustomIcon,
    LanguageSetting,
} from '../Icons/Icon';
import CompanyEventManagement from '../../pages/Admin/EventManagement/CompanyEventManagement';
import ListOrganizer from '../../containers/admin/OrganizerManagement/ListOrganizer';
import SettingBooth from '../../containers/admin/SettingBooth/SettingBooth';
import SettingSeminarRoom from '../../containers/admin/SettingSeminarRoom/SettingSeminarRoom';
import ListViewer from '../../containers/admin/ViewerManagement/ListViewer';
import SurveyManagement from '../../containers/admin/SurveyManagement/SurveyManagement';
import ListRegisterSeminar from '../../containers/admin/RegisterSeminarManagerment/ListRegisterSeminar';
import QAListManagerment from '../../containers/admin/QAListManagerment/QAListManagerment';
import ListAllSeminar from '../../containers/admin/SeminarManagement/ListAllSeminar';
import OuterServerMail from '../../containers/admin/OuterServerMail/OuterServerMail';
import SettingShoppingCart from '../../containers/admin/SettingShoppingCart/SettingShoppingCart';
import OrderProductPaymentManagement from '../../containers/admin/OrderProductPaymentManagement/OrderProductPaymentManagement';
import ListRegisterLiveStream from '../../containers/admin/RegisterLiveStreamManagement/RegisterLiveStreamManagement';
import SettingCustom from '../../containers/admin/SettingCustom/SettingCustom';
import SettingMultiLanguage from '../../containers/admin/SettingMultiLanguage/SettingMultiLanguage';

const dashboardRoutes = [
    {
        path: '/company-event-management',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.companyEventManagement" />,
        icon: Company,
        component: CompanyEventManagement,
        layout: '/admin',
    },
    {
        path: '/all-seminar',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.allSeminar" />,
        icon: ViewListIcon,
        component: ListAllSeminar,
        layout: '/admin',
    },
    {
        path: '/all-live-stream',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.liveStreamManagement" />,
        icon: LiveStreamIcon,
        layout: '/admin',
    },
    {
        path: '/organizer-management',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.organizerManagement" />,
        icon: OrganizerIcon,
        component: ListOrganizer,
        layout: '/admin',
    },
    {
        path: '/viewer-management',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.viewerManagement" />,
        icon: GroupIcon,
        component: ListViewer,
        layout: '/admin',
    },
    {
        path: '/register-seminar-management',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.registSeminarManagement" />,
        icon: SeminarIcon,
        component: ListRegisterSeminar,
        layout: '/admin',
    },
    {
        path: '/register-live-stream-management',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.registerLivestreamManagement" />,
        icon: RegisterLiveStream,
        component: ListRegisterLiveStream,
        layout: '/admin',
    },
    {
        path: '/product-payment-management',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.orderProductPaymentManagement" />,
        icon: ProductPayment,
        component: OrderProductPaymentManagement,
        layout: '/admin',
    },
    {
        path: '/setting-booth',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.settingBooth" />,
        icon: StoreIcon,
        component: SettingBooth,
        layout: '/admin',
    },
    {
        path: '/setting-seminar-room',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.settingSeminarRoom" />,
        icon: RoomIcon,
        component: SettingSeminarRoom,
        layout: '/admin',
    },
    {
        path: '/shopping-cart',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.settingShoppingCart" />,
        icon: SettingShopping,
        component: SettingShoppingCart,
        layout: '/admin',
    },
    {
        path: '/survey-management',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.surveyManagement" />,
        icon: PollIcon,
        component: SurveyManagement,
        layout: '/admin',
    },
    {
        path: '/setting-custom',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.settingCustom" />,
        icon: SettingCustomIcon,
        component: SettingCustom,
        layout: '/admin',
    },
    {
        path: '/setting-multi-language',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.settingMultiLanguage" />,
        icon: LanguageSetting,
        component: SettingMultiLanguage,
        layout: '/admin',
    },
    {
        path: '/qa-management',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.qaManagement" />,
        icon: LiveHelpIcon,
        component: QAListManagerment,
        layout: '/admin',
    },
    {
        path: '/email-outer-server',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.outerServerMail" />,
        icon: MailIcon,
        component: OuterServerMail,
        layout: '/admin',
    },
    {
        path: '/visit-history',
        param: '/:shortName',
        name: <FormattedMessage id="adminSidebar.visitHistory" />,
        icon: VisibilityIcon,
        layout: '/admin',
    },
];

export default dashboardRoutes;
